export const maintenanceWorkflowsTableColumns = [
  { value: 'status', label: 'Status' },
  { value: 'current_forwarding', label: 'Encaminhamento atual' },
  { value: 'process_id', label: 'ID do Processo' },
  { value: 'observations', label: 'Descrição' },
  { value: 'equipment', label: 'Equipamento' },
  { value: 'branch', label: 'Filial' },
  { value: 'creator', label: 'Autor' },
  { value: 'actions', label: 'Ações', className: 'w-11' },
];
